import TrendingSVG from "@design-system/ui-icons/vanilla/Trending"
import { createIcon } from "../createIcon"

export const TrendingIcon = createIcon(TrendingSVG)
